import React from 'react';
import {closeNextStepsSectionPopup, updateNextStepsSectionContents} from '../../actions';
import {connect} from 'react-redux';
import NextStepsSectionEditPopup from './next_steps_section_edit';
import {
    updateTitleFieldInTheSectionEditPopup,
    updateBodyFieldInTheSectionEditPopup
} from '../../sections/actions';

class NextStepsPopup extends React.Component {
    render() {
        return (
            <NextStepsSectionEditPopup
                open={this.props.nextStepsSectionEditOpen}
                title={this.props.nextStepsSectionTitle}
                body={this.props.nextStepsSectionBody}
                onUpdateTitleField={
                    title => this.props.updateNextStepsSectionTitleField(title)
                }
                onUpdateBodyField={
                    body => this.props.updateNextStepsSectionBodyField(body)
                }
                onHandleSubmit={() => {
                    this.props.updateNextStepsSectionContents(
                        this.props.pageId,
                        this.props.nextStepsSectionId,
                        this.props.sectionData,
                        this.props.selectedSettings
                    )
                }}
                onHandleClose={() => {
                    this.props.closeNextStepsSectionPopup();
                }}
            />
        )
    }
}

const mapStateToProps = state => ({
    sectionData: state.pageBuilderSectionPopup.data,
    selectedSettings: state.pageBuilderSectionPopup.settings,
    nextStepsSectionEditOpen: state.pageBuilder.nextStepsSectionPopup.open,
    nextStepsSectionTitle: state.pageBuilderSectionPopup.data.title,
    nextStepsSectionBody: state.pageBuilderSectionPopup.data.body,
    nextStepsSectionId: state.pageBuilderSectionPopup.sectionId,
});

export default connect(
    mapStateToProps, {
        updateNextStepsSectionTitleField: updateTitleFieldInTheSectionEditPopup,
        updateNextStepsSectionBodyField: updateBodyFieldInTheSectionEditPopup,
        updateNextStepsSectionContents: updateNextStepsSectionContents,
        closeNextStepsSectionPopup: closeNextStepsSectionPopup,
    }
)(NextStepsPopup);


// WEBPACK FOOTER //
// ./src/containers/builder/form/popups/next_steps_popup.js